import './CoralAnimatedProductCard.scss'

import { useLocale } from '@websrc/App/Hooks/useLocale'
import { mapCoralWebAnimatedProductCard } from '@websrc/DataMappers/mapSpot'
import React, { FC, useEffect, useRef } from 'react'

import { Asset } from '../Asset/Asset'
import { CTA } from '../CTA'

type CoralAnimatedProductCardProps = ReturnType<typeof mapCoralWebAnimatedProductCard> & {
  visible?: boolean
  type?: string
}
export const CoralAnimatedProductCard: FC<CoralAnimatedProductCardProps> = (props) => {
  const viewCtaRef = useRef<any>(null)
  const cardRef = useRef<HTMLDivElement>(null)
  const locale = useLocale()
  const maxTextLength = 17

  const isLongText =
    (props.button?.text?.length || 0) > maxTextLength ||
    (props.preview_button?.text?.length || 0) > maxTextLength
  useEffect(() => {
    const node = cardRef.current
    if (!node) return
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          observer.disconnect()
        }
      },
      { threshold: 0.22 }
    )
    observer.observe(node)
    return () => observer.disconnect()
  }, [])

  const imageClassName =
    `coral-product-card__image m--type-${props.type}` +
    (props.visible ? ` coral-product-card__image-animate m--type-${props.type}` : '')

  return (
    <div className={'coral-product-card'} ref={cardRef}>
      <div
        className={'coral-product-card__content-container'}
        onClick={() => viewCtaRef.current?.click()}
      >
        <div className={'coral-product-card__body-container'}>
          <div className={'coral-product-card__description'}>{props.headline}</div>
          <div className={'coral-product-card__header'}>{props.description}</div>
        </div>
        <div className={`coral-product-card__image-container m--${props.image_background_color}`}>
          {locale !== 'zh-cn' ? (
            <Asset
              altText={props.asset?.altText}
              className={imageClassName}
              lazyLoading={true}
              objectFit={'cover'}
              thumbnail={props.asset?.thumbnail}
            />
          ) : (
            props.asset?.thumbnail?.url && (
              <img
                alt={props.asset?.altText || props.asset?.thumbnail?.title || ''}
                className={imageClassName}
                loading={'lazy'}
                src={props.asset.thumbnail.url}
              />
            )
          )}
        </div>
      </div>
      <div
        className={`coral-product-card__buttons-container${isLongText ? ' m--column-force' : ''}`}
      >
        <CTA
          className={
            'coral-global-button m--type-fill m--theme-white m--size-md coral-product-card__button-override'
          }
          cta={props.button}
          ref={viewCtaRef}
          type={'clean'}
        />
        <CTA
          className={
            'coral-global-button m--type-outline m--theme-white m--size-md coral-product-card__button-override'
          }
          cta={props.preview_button}
          iconDirection={'right'}
          iconName={'upRightArrow'}
          type={'clean'}
        />
      </div>
    </div>
  )
}
